module.exports = __webpack_public_path__ + "44ba5f347aade040b1c957de7c7b803b.svg";